// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"309":"e3e4860d","841":"5523ffca"}[chunkId] + ".chunk.js";
};